import { css } from '@huspy/styled-system/css';

const creditExpirationBannerStyles = {
  wrapper: css({
    padding: 5,
    borderLeft: '2px solid',
    borderRight: '2px solid',
    borderColor: 'var(--colors-border-secondary)',
    backgroundColor: 'var(--colors-base-white)',
  }),
  alert: css({
    backgroundColor: 'var(--colors-warning-100)',
    borderColor: 'var(--colors-warning-200)',
    borderRadius: 5,
  }),
  content: css({ display: 'block' }),
  closeButton: css({ marginTop: '5px' }),
};

export default creditExpirationBannerStyles;
